module.exports = {
        srcSet: __webpack_public_path__ + "static/media/movingVehicle-498.e2885b59.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/movingVehicle-498.e2885b59.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/movingVehicle-498.e2885b59.webp",
        toString: function(){return __webpack_public_path__ + "static/media/movingVehicle-498.e2885b59.webp"},
        
        width: 498,
        height: 498
      }